import { Component, OnInit, OnDestroy } from '@angular/core';
import { MensagensService } from 'max-ng-lib';

import { ParametroPortalService } from '../../../../../services';
import { ParametroModel } from '../../configuracoes/parametros/parametro.model';
import {
    ConfiguracaoWhatsapp,
    ConfiguracaoWhatsappTemplate,
    ConfiguracaoWhatsappTemplateCampos,
} from '../../models/ferramentas/configuracao-whatsapp.model';
import { SubheaderService } from './../../../../../core/services/layout/subheader.service';
import { ConfiguracaoWhatsappService } from './../../../../../services/configuracao-whatsapp.service';
import { LinksBaseConhecimentoService } from './../../../../../services/links-base-conhecimento.service';
import { TipoTemplateWhatsappService } from './../../../../../services/tipo-template-whatsapp.service';

@Component({
	selector: "m-configuracao-timeline-whatsapp",
	templateUrl: "./configuracao-timeline-whatsapp.component.html",
	styleUrls: ["./configuracao-timeline-whatsapp.component.scss"],
})
export class ConfiguracaoTimelineWhatsappComponent implements OnInit, OnDestroy {
	parametros = ["NUMERO_INTEGRACAO_WHATSAPP", "TOKEN_INTEGRACAO_WHATSAPP"];
	modelo: ConfiguracaoWhatsapp = {};
	tokenDeIntegracao: ParametroModel = {};
	numeroDeIntegracao: ParametroModel = {};
	templates: ConfiguracaoWhatsappTemplate[] = [{}, {}];
	templatesClone: ConfiguracaoWhatsappTemplate[];
	isCarregou: boolean = false;
	params: ConfiguracaoWhatsappTemplateCampos = {
		"{{cnpj_cpf}}": "{{cnpj_cpf}} - CNPJ ou CPF",
		"{{razao_social}}": "{{razao_social}} - Razão Social do Cliente",
		"{{nome_fantasia}}": "{{nome_fantasia}} - Nome Fantasia do Cliente",
		"{{numero_pedido}}": "{{numero_pedido}} - Número do Pedido",
		"{{data_entrega}}": "{{data_entrega}} - Data de Entrega",
		"{{data_recebimento}}": "{{data_recebimento}} - Data de Recebimento",
		"{{valor_pedido}}": "{{valor_pedido}} - Valor do Pedido",
		"{{numero_nota}}": "{{numero_nota}} - Número da Nota Fiscal",
	};
	campos: string[] = Object.keys(this.params);
	regexTemplate = /{{(.*?)}}/gi;
	constructor(
		private mensagemService: MensagensService,
		private subheaderService: SubheaderService,
		private parametroPortalService: ParametroPortalService,
		private tipoTemplateWhatsappService: TipoTemplateWhatsappService,
		private configuracaoWhatsappService: ConfiguracaoWhatsappService,
		private linksBaseConhecimentoService: LinksBaseConhecimentoService,
	) {}

	ngOnInit() {
		this.subheaderService.botoesHeader.push(
			{
				class: 'baseDeConhecimento',
				icon: 'fas fa-question',
				acao: () => this.getLinkBaseConhecimento(),
				tooltip: 'Base de Conhecimento',
			}
		)
		this.buscarParametrosDeIntegracaoWhatsapp();
		this.listarTodosTiposTemplateWhatsapp();
	}

	ngOnDestroy(): void {
		this.subheaderService.botoesHeader = this.subheaderService.botoesHeader.filter(botao => botao.class !== 'baseDeConhecimento');
	}

	async buscarParametrosDeIntegracaoWhatsapp() {
		const parametros = await this.parametroPortalService
			.obterParametroPorTipos(...this.parametros)
			.toPromise();
		if (parametros.length) {
			const [numeroDeIntegracao, tokenDeIntegracao] = parametros;
			this.numeroDeIntegracao = numeroDeIntegracao;
			this.tokenDeIntegracao = tokenDeIntegracao;
		}
	}

	async salvar() {
		try {
			this.validarParametros();
			this.validarCampos();
			this.fazerRequestParaSalvarTempletes();
		} catch (e) {
			this.mensagemService.exibaToastAlerta(e.message);
		}
	}

	async fazerRequestParaSalvarTempletes(){
		this.modelo.parametros = [this.numeroDeIntegracao,this.tokenDeIntegracao];
		this.modelo.templates = this.templates;
		await this.configuracaoWhatsappService.salvarIntegracaoWhatsapp(this.modelo).toPromise();
	    this.mensagemService.exibaToastSucesso("Configuração salva com sucesso!");
	}

	validarCampos() {
		if (this.tokenDeIntegracao && !this.tokenDeIntegracao.valor) {
			this.lancarExcecao("O token de integração é obrigatório");
		}
		if (this.numeroDeIntegracao && !this.numeroDeIntegracao.valor) {
			this.lancarExcecao("O campo telefone é obrigatório");
		}
	}


	validarParametros() {
		this.templates.forEach(({ mensagemPadrao, descricao, ativo }) => {
			if (mensagemPadrao) {
				this.validarMatch(mensagemPadrao, descricao);
			}else if(ativo){
				this.lancarExcecao(`${descricao}: Templates de mensagem são obrigatórios`);
			}
		});
	}

	validarMatch(mensagemPadrao: string, descricao: string) {
		const temParametros = mensagemPadrao.match(this.regexTemplate);
		if (temParametros) {
			const campos = temParametros.filter((key) => !this.params[key]).map((key) => `${key}`);
			if (campos.length) {
				this.lancarExcecao(`O template ${descricao} possui os seguintes campos não definidos corretamente: ${campos}`);
			}
		}
	}

	async listarTodosTiposTemplateWhatsapp() {
		this.templates = await this.tipoTemplateWhatsappService
			.listarTodosTiposTemplateWhatsapp()
			.toPromise();
		this.templatesClone = this.templates.map((template) => ({ ...template }));
		this.isCarregou = true;
	}

	lancarExcecao(mensagem: string) {
		throw new Error(mensagem);
	}




	getClass = (valor)  => ({
		'APROVADO': 'status-aprovado',
		'PENDENTE': 'status-pendente',
		'REJEITADO': 'status-rejeitado'
	})[valor] || 'sem-status';

	getLinkBaseConhecimento() {
		const {url} = this.linksBaseConhecimentoService.getLinkBaseConhecimento('GUIA_INTEGRACAO_WHATSAPP');
		window.open(url, '_blank');
	}

	permitirAbrirDetails(isAtivo: boolean, details, openOrClose:boolean, index:number){
		isAtivo ? details.open = openOrClose: ''
		if(!openOrClose && isAtivo){
			this.templates[index].mensagemPadrao = this.templatesClone[index].mensagemPadrao;
		}
	}
}

